import { FormField, useMainFormContext } from '@/_components';
import {
  CardContainer,
  FormMediaInput,
  ImageTextHeader,
  PageHeaderCtrlContainer,
  StatusButtonInput,
  useMedia,
} from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';
import type { OnPartialUpdate } from '@/_schemas/types';
import { nameResolver } from '@/_shared';

import { FriendlyStatus } from './friendly-status';

import { useCompetitorFormContext } from '../../form-context';
import type { CompetitorUpdateSchema } from '../../schemas';

export function Header({
  onUpdate,
  isPending,
  isEditable,
}: {
  isEditable: boolean;
  isPending: boolean;
  onUpdate: OnPartialUpdate<CompetitorUpdateSchema>;
}) {
  const form = useCompetitorFormContext();
  const { isSubmitting: isSubmittingMainForm } = useMainFormContext();

  const [name, id] = form.watch(['name', 'id']);

  const folder_path = `competitors/${id}`;

  const { onImageUpdate } = useMedia(onUpdate);

  return (
    <CardContainer bodyClassName="flex">
      <PageHeaderContainer>
        <ImageTextHeader
          imageSlot={
            <div className="h-[6.125rem]">
              <FormField
                control={form.control}
                name="logo"
                render={({ field: { ref: _, ...field } }) => (
                  <FormMediaInput
                    {...field}
                    shape="rectangle"
                    addPadding
                    height={192}
                    width={244}
                    label=""
                    disabled={!isEditable}
                    folder_path={folder_path}
                    onImageStateChange={onImageUpdate}
                  />
                )}
              />
            </div>
          }
          primarySlot={nameResolver(name, undefined)}
          secondarySlot={
            <PageHeaderCtrlContainer>
              <StatusButtonInput isPending={isPending || isSubmittingMainForm} onUpdate={onUpdate} />
              <div className="border-c-border-muted mt-1 h-5 w-px border-r" />
              <FriendlyStatus isPending={isPending || isSubmittingMainForm} onUpdate={onUpdate} />
            </PageHeaderCtrlContainer>
          }
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
